/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";

import { rgba } from "polished";
import { fontSize } from "../common/styled-mixins";

import type { AccountType } from "./AccountInHeader";

const Tab = React.memo(styled.div`
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  align-content: center;
  justify-content: flex-start;
  align-self: stretch;
  min-width: 33%;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 12px 18px;
  font-size: ${fontSize(14)};
  line-height: 1;
  color: ${({ theme }) => rgba(theme.alternativeForeground, 0.8)};
  background-clip: padding-box;
  cursor: pointer;

  :not(:first-of-type) {
    border-left: 1px solid transparent;
  }

  :hover {
    background-color: ${props => props.theme.toggleAccountLightBg};
    color: ${({ theme }) => theme.foreground};
  }

  @media (max-width: 959px) {
    padding: 17px 18px;
    font-size: ${fontSize(12)};
    white-space: normal;
    align-items: center;
    background-color: ${props => props.theme.toggleAccountDarkBg};
  }

  @media (max-width: 360px) {
    padding: 15px 13px;
  }

  @media (max-width: 320px) {
    padding: 13px 11px;
  }

  ${({ active, theme }) =>
    active &&
    css`
      background-color: ${theme.toggleAccountLightBg};

      @media (max-width: 959px) {
        background-color: ${props => props.theme.toggleAccountLightBg};
      }
    `};
`);

const Heading = React.memo(styled.h3`
  font-weight: 400;
  line-height: inherit;
  text-transform: capitalize;
  pointer-events: none;

  @media (min-width: 959px) {
    line-height: 20px;
  }

  @media (max-width: 959px) {
    margin-bottom: 0;
    font-size: ${fontSize(12)};
    text-align: center;
  }

  color: ${({ tab, theme }) => {
    switch (tab) {
      case "tournament":
        return theme.mode === "dark" ? "#ffffff" : theme.foreground;
      case "real":
        return "#3B9478";
      case "demo":
        return "#FFCC00";
      default:
        return "#919191";
    }
  }};
`);

type Props = {
  currentTab?: AccountType,
  onClick: (tab: AccountType) => boolean | void,
  tab: AccountType,
  children: Array<React.Node>
};

export default function AccountTab({
  currentTab,
  tab,
  onClick,
  children
}: Props) {
  const isActive = React.useMemo(() => currentTab === tab || (currentTab === "real_stub" && tab === "real"), [currentTab, tab]);
  const clickHandler = React.useCallback(
    () => onClick(tab),
    [tab],
  )

  return (
    <Tab active={isActive} onClick={clickHandler}>
      <Heading tab={tab} active={isActive}>
        {children}
      </Heading>
    </Tab>
  );
}



// WEBPACK FOOTER //
// ./src/components/AccountType/Tab.js